import methods from '../methods'

export default {
    user: null,
    auth: null,
    menu: [
        {
            label: 'Parlamentares e Governantes',
            route: null,
            url: process.env.VUE_APP_ENDPOINT_URL + 'cargos-partidarios',
            funcao: null,
            params: {},
            viewFooter: false,
            viewHeader: true,
        },
        {
            label: 'Direções e Diretórios',
            route: null,
            url: process.env.VUE_APP_ENDPOINT_URL + 'cargos-partidarios/direcoes-e-diretorios',
            funcao: null,
            params: {},
            viewFooter: false,
            viewHeader: true,
        },

        {
            label: 'PCdoB Digital',
            route: null,
            url: null,
            funcao: () => {
              methods.redirectToRV(process.env.VUE_APP_ENDPOINT_URL)
            },
            params: {},
            viewFooter: false,
            viewHeader: true,
        },
        {
            label: 'Contribua',
            route: null,
            url: process.env.VUE_APP_ENDPOINT_URL + 'contribuicao',
            funcao: null,
            params: {},
            viewFooter: false,
            viewHeader: true,
        },


    ],
}



// WEBPACK FOOTER //
// ./src/vuex/state.js